import getPageBySlug from '../api/queries/pages/getPageBySlug';
import PageLayout from '../components/PageLayout';
import CDF from '../components/Sections/CDF';

import createApolloClient from '../api/index';
import getMenu from '../api/queries/menus/getMenu';
import Breadcrumb from '../components/Breadcrumb';

const client = createApolloClient();

const Guides = ({ pageBy, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData }) => {
  const pageName = {
    pageBy: {
      title: 'Guides',
      slug: 'guides',
    },
  };
  const indexStatus = {
    indexPage: true,
  };

  const seo = {
    title: 'Employment Law Guides | Monaco Solicitors',
    description:
      'Find relevant guides on all areas of employment law, brought to you by the expert team of lawyers at Monaco Solicitors.',
  };

  return (
    <PageLayout
      menuData={desktopHeaderData}
      aboutMenuData={aboutMenuData}
      serviceMenuData={serviceMenuData}
      toolsMenuData={toolsMenuData}
      seo={seo}
      title="Guides"
      indexStatus={indexStatus}
    >
      <Breadcrumb data={pageName} />
      <div className="guides">
        <h1>Guides</h1>
        <h2>Main Cases</h2>
        {pageBy.caseTypes?.mainCasesLinks.map((mainCase) => {
          return (
            <div className="guides__main-cases">
              <a href={mainCase.mainCasesUrl.url}>{mainCase.mainCasesLink}</a>
            </div>
          );
        })}
        <h2>Specific cases</h2>
        {pageBy.caseTypes?.specificCasesLinks.map((specificCase) => {
          return (
            <div className="guides__specific-cases">
              <a href={specificCase.specificCasesUrl.url}>{specificCase.specificCasesLink}</a>
            </div>
          );
        })}
        <div>
          <h2>Next Steps</h2>
          <p>
            To see whether we could offer you a free or paid consultation, just get in touch below…
          </p>

          <CDF />
        </div>
      </div>
    </PageLayout>
  );
};

export default Guides;

export async function getStaticProps() {
  const serviceMenuId = process.env.APP_ENV === 'stage' ? 'dGVybTo2Mg==' : 'dGVybTo2Ng==';
  const { data } = await client.query(getPageBySlug('/case-types/'));
  const { pageBy } = data;
  const desktopHeaderData = await client.query(getMenu('dGVybToyNQ=='));
  const aboutMenuData = await client.query(getMenu('dGVybTo1NQ=='));
  const serviceMenuData = await client.query(getMenu(serviceMenuId));
  const toolsMenuData = await client.query(getMenu('dGVybTo1Ng=='));

  return { props: { pageBy, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData }, revalidate: 10 };
}
